import React from "react";
import { WifiOff, RefreshCw } from "lucide-react";
import { useOfflineStatus } from "../lib/offlineManager";

// Bandeau clair en haut de l'app pour indiquer l'état hors ligne / la synchronisation.
const OfflineBanner = () => {
  const { isOffline, syncStats } = useOfflineStatus();
  const pending = syncStats?.pending || 0;

  if (!isOffline && pending === 0) return null;

  if (isOffline) {
    return (
      <div
        className="w-full bg-amber-500 text-white px-4 py-2.5 flex items-center justify-center gap-2 text-sm font-medium shadow flex-wrap"
        data-testid="offline-banner"
      >
        <WifiOff className="w-4 h-4 shrink-0" />
        <span className="inline-flex items-center gap-1.5 bg-white/25 rounded-full px-2.5 py-0.5 font-semibold" data-testid="offline-badge">
          <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
          Connecté hors-ligne
        </span>
        <span>
          — vos actions sont enregistrées et seront synchronisées automatiquement au retour de la connexion
          {pending > 0 ? ` (${pending} en attente)` : ''}.
        </span>
      </div>
    );
  }

  // De retour en ligne avec des éléments à synchroniser
  return (
    <div
      className="w-full bg-blue-600 text-white px-4 py-2.5 flex items-center justify-center gap-2 text-sm font-medium shadow"
      data-testid="offline-banner-syncing"
    >
      <RefreshCw className="w-4 h-4 shrink-0 animate-spin" />
      <span>Connexion rétablie — synchronisation de {pending} élément(s) en cours…</span>
    </div>
  );
};

export default OfflineBanner;
